"use client"
import styled from "@emotion/styled"
import { Button } from "@mui/material"
import { usePathname } from "next/navigation"
import { FC, Suspense, useEffect, useRef } from "react"
import { Desktop } from "../common/bit/MediaQueries"
import BgRebuildAnalytics from "./BgRebuildAnalytics"

const StyledMain = styled.div`
  :focus {
    outline: 0;
  }
`

const StyledButton = styled(Button)`
  position: fixed;
  z-index: -10;
  background-color: black;
  color: white;
  top: -100px;
  &:focus-visible {
    z-index: 9999999;
    top: 0px;
  }
`

const BgRebuildLayout: FC<any> = ({ locale, children }) => {
  const mainRef = useRef<HTMLDivElement>(null)
  const pathname = usePathname()

  const handleClick = () => {
    if (mainRef.current) {
      mainRef.current.focus()
    }
  }

  useEffect(() => {
    // Dispatch route-change-callbox event whenever pathname changes
    const event = new CustomEvent("route-change-callbox", {
      detail: {
        pathname,
        timestamp: new Date().getTime(),
      },
    })
    document.dispatchEvent(event)
  }, [pathname])

  return (
    <>
      <Suspense>
        <BgRebuildAnalytics />
      </Suspense>
      <Desktop>
        <StyledButton id="skip-to-content" tabIndex={3} onClick={handleClick}>
          {locale === "he" ? "דלג לתוכן המרכזי" : "skip navigation"}
        </StyledButton>
      </Desktop>
      {/* <Cookies /> */}

      <>
        <StyledMain id="mainContent" tabIndex={-1} ref={mainRef} role="main">
          {children}
        </StyledMain>
      </>
    </>
  )
}

export default BgRebuildLayout
